export enum RetrievalAccessibility {
    API = 'API',
    STREAMING = 'STREAMING',
    FILE = 'FILE',
}
